import { Component, Input } from "@angular/core";
import { InlineTableData } from "../data-table/data-table.component";

@Component({
  selector: "doughnut-legend-table",
  templateUrl: "./doughnut-legend-table.component.html",
  styleUrls: ["./doughnut-legend-table.component.scss"],
  styles: [":host { display: contents; }"],
})
export class DoughnutLegendTableComponent {
  @Input() data: InlineTableData;
  @Input() headers: string[] = null;
  @Input() extraClass: string = "";
  @Input() isReport: boolean = false;
}
